import { render, staticRenderFns } from "./SingleAdmin.vue?vue&type=template&id=070d54f5&scoped=true&"
import script from "./SingleAdmin.vue?vue&type=script&lang=ts&"
export * from "./SingleAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./SingleAdmin.vue?vue&type=style&index=0&id=070d54f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070d54f5",
  null
  
)

export default component.exports